import { Button, TextInput } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useChangePasswordForm } from 'src/Hooks/Forms/useChangePasswordForm';
import { useUpdatePasswordWithToken } from 'src/Hooks/Mutations/useUpdatePasswordWithToken';

import styles from './ChangePasswordWithToken.module.scss';
import { Props } from './ChangePasswordWithToken.types';

const ChangePasswordWithToken = ({ token }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const openInfoModal = useCallback(() => {
    modals.openContextModal({
      modal: 'info',
      title: t('auth.changePassword.changedModal.title', 'Mot de passe modifié !'),
      centered: true,
      innerProps: {
        content: t(
          'auth.changePassword.changedModal.content',
          'Vous pouvez vous reconnecter avec votre nouveau mot de passe.'
        ),
        confirmText: t('auth.changePassword.changedModal.close', 'Se connecter'),
        onConfirm: () => navigate('/auth/'),
      },
    });
  }, [navigate, t]);

  const { form } = useChangePasswordForm();

  const { mutate, isLoading } = useUpdatePasswordWithToken({ onSuccess: () => openInfoModal() });

  return (
    <form
      onSubmit={form.onSubmit(values => mutate({ password: values.password, token }))}
      className={styles.container}
    >
      <div className={styles.title}>{t('auth.changePassword.title', 'Nouveau mot de passe')}</div>
      <div className={styles.subtitle}>
        {t('auth.changePassword.subtitle', 'Entrez votre nouveau mot de passe pour votre compte')}
      </div>
      <TextInput
        placeholder={t('auth.changePassword.password', 'Nouveau mot de passe')}
        type="password"
        {...form.getInputProps('password')}
      />
      <TextInput
        placeholder={t('auth.changePassword.confirmPassword', 'Confirmez votre mot de passe')}
        type="password"
        {...form.getInputProps('confirmPassword')}
      />
      <Button type="submit" loading={isLoading}>
        OK
      </Button>
    </form>
  );
};

export default ChangePasswordWithToken;
